<template>
  <div>
  <v-form @submit.prevent="formSubmit(0)" class="va-search d-flex align-center" :class="{'dense': dense}" :style="getStyle">

          <v-text-field
            ref="globalSearchInput"
            solo
            outlined
            dense
            :disabled="searchDisabled"
            id="global-search-input-field"
            label='Use * for wildcards and " for exact phrases'
            light
            append-inner
            prepend-inner-icon="mdi-magnify"
            v-model="searchtext"
            @keyup="countAndSubmit"
            v-on:keyup.enter="formSubmit(0)"
            v-on:keyup.escape="checkClear"
            :persistent-hint="persistentHint"
            :hint="hint"
            :hide-details="hint === ''"
            :loading="loading"
            class="search-input"
            :style="$vuetify.breakpoint.smAndUp ? 'background-color: rgba(255, 255, 255, 0.9) !important;min-width: 80%;' : 'background-color: rgba(255, 255, 255, 0.9) !important;'"
            autocomplete="off"
            accesskey="f"
          >
            <template slot="append">
              <v-icon @click="clearSearch()">clear</v-icon>
              <v-progress-circular indeterminate v-show="loading"></v-progress-circular>
            </template>
          </v-text-field>

    <v-btn
      v-if="! hideButton"
      :dense="dense"
      height="40"
      :style="!$vuetify.breakpoint.smAndUp ? 'min-width: 52px; padding: 0' : ''"
      color="primary"
      :x-large="xlarge"
      :x-small="xsmall"
      :small="small"
      :large="large"
      @click.stop="formSubmit(0)">
      <span v-if="$vuetify.breakpoint.smAndUp">Search</span>
      <v-icon v-else>mdi-magnify</v-icon>
    </v-btn>
  </v-form>
  <v-dialog
    v-model="showOverlay"
    hide-overlay
    :retain-focus="false"
  :fullscreen="$vuetify.breakpoint.smAndDown"
  :content-class="$vuetify.breakpoint.smAndDown ? 'useHeight' : 'useHeight search-overlay-dialog'"
  :max-height="'100vh'"
  >
    <SearchOverlay

      :results="results"
      :loading="loading"
      :searchtext="searchtext"
      @close="showOverlay = false"
      @previous="loadPrevious"
      @next="loadNext"
      :searchPack="searchPack"
      :totalres="totalres"

      @update:searchtext="searchtextChanged"
      @addnext="addnext"
    />
  </v-dialog>
  </div>
</template>

<script>
import {getOSDURL, getCaveLabel, getCaveShortLabel, getBibTitle, getWallLabels} from  "@/utils/helpers"
import { searchRoot } from '@/services/repository'
import thumbnail from '@/components/thumbnail'

import SearchOverlay from "./SearchOverlay.vue"

export default {

  name: 'GlobalSearch',

  components: {
    thumbnail,
    SearchOverlay
  },

  props: {

    filled: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    },
    xlarge: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    xsmall: {
      type: Boolean,
      default: false
    },
    hideButton: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: true
    },
    persistentHint: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {

      results: Array,
      start: 0,
      showResults: false,
      previousUrl: '',
      nextUrl: '',
      loading: false,
      secountAndSubmitarchtext: "",
      searchPack: null,
      totalres: null,
      maxHeight: "300px",
      showOverlay: false,
      searchtext: "",
      batchSize: 20
    }
  },
  computed: {
    getResultsForText(){
      if (this.searchtext === undefined || this.searchtext === ""){
        return "Please enter a search term."
      } else {
        return 'Results for' + ': ' +  this.searchtext
      }
    },
    getSearchRangeText(){
      if (this.totalres > 0){
        return `Results: ${this.results.length} of ${this.totalres} shown`
      } else {
        return ""
      }
    },

    getStartNumber(){
      return this.searchPack + 1
    },
    getStyle(){
      if (this.$vuetify.breakpoint.xs){
        return "width: 100%; margin: 0;"
      } else if (this.$vuetify.breakpoint.sm){
        return "width: 100%; margin: 0;"
      } else if (this.$vuetify.breakpoint.md){
        return "width:80%;margin: 0 auto;"
      } else if (this.$vuetify.breakpoint.lg){
        return "width:80%;margin: 0 auto;"
      } else if (this.$vuetify.breakpoint.xl){
        return "width:80%;margin: 0 auto;"
      } else {
        return "width:80%;margin: 0 auto;"
      }
    },
    searchDisabled(){
      return this.$store.state.searchDisabled
    },
    searchPackEnd(){
      return this.searchPack + this.results.length;
    },
    // searchPack:{
    //   get: function(){
    //     return this.$store.state.searchPack;
    //   },
    //   set: function (newValue){
    //     newValue = this.searchPackBuffer
    //     if (!this.searchPackIsWaitingForSaving){
    //       this.searchPackIsWaitingForSaving = true
    //       let _self = this
    //       setTimeout(function(){
    //         _self.$store.commit("setSearchPack", this.searchPackBuffer)
    //         _self.searchPackIsWaitingForSaving = false
    //       }, 1000);
    //     }
    //   }
    // },
    // totalres:{
    //   get: function(){
    //     return this.$store.state.totalRes;
    //   },
    //   set: function (newValue){
    //     this.$store.commit("setTotalRes", newValue)
    //   }
    // },

    // searchtext:{
    //   get: function(){
    //     return this.$store.state.searchText;
    //   },
    //   set: function (newValue){
    //     newValue = this.searchTextBuffer
    //     if (!this.searchTextIsWaitingForSaving){
    //       this.searchTextIsWaitingForSaving = true
    //       let _self = this
    //       setTimeout(function(){
    //         _self.$store.commit("setSearchText", this.searchTextBuffer)
    //         _self.searchTextIsWaitingForSaving = false
    //       }, 1000);
    //     }
    //   }
    // },
    b_size() {
      return this.$vuetify.breakpoint.smAndUp ? 10 : 4
    },
    legendButtonProps() {
      return { icon: true }
    },
    legendItems() {
      let legend = []
      let legendObject = {}
      legendObject.title = "Title"
      legendObject.items = [];
      legendObject.items.push({vhtml: this.buildLegendIcon(this.getHtmlIcon('mdi-menu-up')), description:"description", itemClasses: "reducedPaddingTop"})
      legendObject.items.push({vhtml: this.buildLegendIcon(this.getHtmlIcon('mdi-menu-down')), description: "description", itemClasses: "reducedPaddingTop"})
      legendObject.items.push({vhtml: this.buildLegendIcon(this.getHtmlIcon('mdi-keyboard-return', 14)), description: ""})
      let legendAccessKey = {}
      legendAccessKey.items = [];
      legend.push({ block: [legendObject], width: 60 })
      legend.push({ block: [legendAccessKey], width: 60 })
      return legend
    },

  },

  methods: {
    searchtextChanged(e, searchtext){
      this.$log.debug("searchtextChanged", e, searchtext)
      this.searchtext = searchtext
      this.countAndSubmit(e)
    },
    updateMenuHeight() {
      this.$nextTick(() => {
        const el = this.$refs.globalSearchInput?.$el
        if (!el) return

        const rect = el.getBoundingClientRect()
        const spaceBelow = window.innerHeight - rect.bottom - 8

        this.maxHeight = spaceBelow + "px"
      })
    },


    checkFocus(e) {
      if (document.activeElement === e.target && !this.showResults && this.searchtext && this.searchtext.length > 2) {
        this.showResults = true
      }
    },


    clearSearch(){
      this.$log.debug("execute clear")
      this.searchtext = '';
      this.showResults = false;
      this.results = []
      this.totalResults = 0
      this.totalres = 0
      this.start = 0

    },
    checkClear() {
      this.searchtext = '';
      this.showResults = false;
    },

    buildLegendIcon(text) {
      return '<div class="va-key-symbol" style="border: 1px solid black; width: 48px; height: 28px; padding: 4px; text-align: center;">' + text + '</div>'
    },
    getHtmlIcon(iconname, fontSize) {
      let fontstyle = ""
      if (fontSize) {
        fontstyle = ' style="font-size: ' + fontSize + 'px;"'
      }
      let theme = this.$vuetify.theme.isDark ? 'theme--dark' : 'theme--light'
      return '<i aria-hidden="true" class="v-icon notranslate mdi ' + iconname + ' ' + theme + '"' + fontstyle + '></i>'
    },

    focusOnInput() {
      this.$log.debug('call focus')
      this.$nextTick(() => {
        this.$log.debug("focusOnImput started.");
        this.$refs.globalSearchInput && this.$refs.globalSearchInput.focus()
        this.$log.debug('ref: ', this.$refs.globalSearchInput.$el)
        this.$log.debug('active: ', document.activeElement)
      });

    },


    countAndSubmit(e) {
      this.searchPack = 0
      if (e.location !== 0 || e.code.startsWith('Arrow') || e.code === "Insert" || e.code === "CapsLock" || e.code === "PageUp"  || e.code === "PageDown" || e.code === "End"  || e.code === "Home" || e.code.startsWith('F')) {
        return
      }
      if (this.searchtext && this.searchtext.length > 2 ) {
        this.waitForChanges(this.searchtext)
      } else {
        this.results = []
        this.totalResults = 0
        this.totalres = 0
        this.totalResults = []
        this.showResults = false
      }
    },
    waitForChanges(search) {
      let cancel = false
      const max = 10
      const millisec = 100
      let self = this
      let i = 0
      let timeid = setInterval( () => {
        if (self.searchtext !== search) {
          this.$log.debug('cancel', i)
          cancel = true
          i = max - 1
          clearInterval(timeid)
        }
        if (i === max - 1 && !cancel) {
          this.$log.debug('submit')
          clearInterval(timeid)
          self.formSubmit(0)
        }
        i++
      }
        , millisec)
    },
async addnext(batchSize) { // Hier empfangen wir die Zahl (z.B. 20)
  this.$log.debug("handleLoadMore addnext", batchSize)
  if (this.loading) return;

  this.loading = true;
  this.searchPack += batchSize; // Nutze den Wert vom Grid

  var params = {}
  params["searchtext"] = this.searchtext
  params["batchStart"] = this.searchPack
  params["batchSize"] = batchSize // Nutze den Wert vom Grid für das Backend

  searchRoot(params, this.$store.state.mapping)
    .then( res => {
      this.results = this.results.concat(res.data.hits.hits);
      this.loading = false;
      this.totalres = res.data.hits.total.value;
    }).catch((error) => {
      console.log(error);
      this.loading = false;
    })
},

    async formSubmit(batch) {
      this.updateMenuHeight()
      if (this.searchtext && batch === 0) {
        this.results = []
        this.totalres = 0
        this.start = 0
        this.totalResults = 0
        this.searchPack = 0 // Wichtig: Beim Neusuchen den Offset zurücksetzen!

        var params = {}
        params["searchtext"] = this.searchtext
        params["batchStart"] = batch
        params["batchSize"] = this.batchSize // NEU

        this.loading = true

        if (!this.$store.state.mapping || Object.keys(this.$store.state.mapping).length === 0) {
          console.warn("mapping missing → fetching now")
          await this.$store.dispatch("fetchMapping")
        }

        searchRoot(params, this.$store.state.mapping)
          .then( res => {
            if (res.data.hits.total.value === 0){
              this.loading = false
              this.showResults = false;
              this.results = []
              this.totalResults = 0
              this.totalres = 0
              this.start = 0
              return;
            }
            this.showOverlay = true
            this.totalres = res.data.hits.total.value;
            this.results = res.data.hits.hits // Da initial, .concat weglassen oder [] nutzen
            this.totalResults = res.data.hits.total.value
            this.showResults = true
            this.loading = false


            this.$matomo && this.$matomo.trackSiteSearch(this.$store.state.searchtext, 'global', this.totalResults)
          }).catch(function (error) {
            console.log(error);
            this.loading = false;
            return null
          })
      }
    },
    loadPrevious() {
      this.searchPack -= 10
      this.formSubmit(this.searchPack)
    },

    loadNext() {
      this.searchPack += 10
      this.formSubmit(this.searchPack)
    },

    keyHandler(event) {
      if (event.code === "PageDown" && this.showResults) {
        event.preventDefault()
        this.loadNext()
      }
      if (event.code === "PageUp" && this.showResults) {
        event.preventDefault()
        this.loadPrevious()
      }

    }


  },

  mounted() {
    this.results = []
    this.$log.debug("GlobalSearch mounted", this.$route);
    if (this.$route.query?.term){
      this.searchtext = this.$route.query.term
      this.results = []
      this.totalResults = 0
      this.totalres = 0
      this.totalResults = []
      this.showResults = false
    }
    this.updateMenuHeight()
    window.addEventListener("keydown", this.keyHandler );
    window.addEventListener("resize", this.updateMenuHeight)
    if (this.searchtext){
      if (this.searchtext.length > 2){
        this.formSubmit(this.searchPack)
      }
    }

  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.keyHandler );
    window.removeEventListener("resize", this.updateMenuHeight)
  }


}
</script>


<style lang="css" scoped>


.search-results-header{
  position: sticky;
  top:0px;
  background-color: white !important;
  z-index: 10;
}
.v-menu__content {
  max-width: 0;
}

.va-search.dense .v-menu__content {
  max-width: 300px;
}

.resultMenu .v-list-item__title {
 white-space: normal;
 font-size: 0.9em;
}

.resultMenu {
   max-height: 300px;
}

.resultMenu .v-list-item__action {
  margin: 0px !important;
 padding: 4px;
}

.btn-key-hint  {
  font-size: 10px;
  margin-top: -10px;
  text-align: center;
  text-transform: uppercase;
}

.va-portal >>> .legend-icon {
  width: 150px;
}

.va-key-symbol {
  font-size: 0.85em;
}
.v-list-item__subtitle {
  white-space: break-spaces;
}
.v-list-item-content p em {
  background-color:rgba(255, 255, 0, 0.665);
}
.highlight{
  background-color: rgba(255, 255, 0, 0.665);
}
:deep(.v-list-item__content p em) {
  background-color: rgba(255, 255, 0, 0.665) !important;
}
p em {
  background-color: rgba(255, 255, 0, 0.665) !important;
}
.reducedPaddingTop .va-key-symbol {
  padding-top: 2px !important;
}
/* Fix für das Scrolling und die Position */
.scrollable-results {
  padding: 0px;
  -webkit-overflow-scrolling: touch; /* Flüssiges Scrollen auf iOS */
}

/* Spezifischer Fix für den Menü-Container (der nun am Body hängt) */
:deep(.safari-menu-fix) {
  background: white;
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  border-radius: 4px;
  /* Verhindert, dass Safari das Menü irgendwo im Nirgendwo rendert */
  margin-top: 2px;
}
:deep(.safari-menu-overlay) {
  /* Erlaubt dem Menü, fast den ganzen Bildschirm zu füllen */
  max-height: 85vh !important;
  display: flex !important;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15) !important;
  background: white;
  overflow-y: auto !important;
}
/* Die Liste im Inneren des Fensters */
.result-list-scroll {
  flex: 1 1 auto;
  overflow-y: auto !important;
  /* Verhindert "Gummiband"-Effekt-Probleme in Safari */
  -webkit-overflow-scrolling: touch;
}

/* Fix für den Sticky Header in der Liste */
.search-results-header {
  position: -webkit-sticky; /* Safari Support */
  position: sticky;
  top: 0;
  z-index: 10;
}
.va-search {
  overflow: visible !important;
  /* Wichtig für Safari, um den Stacking Context sauber zu halten */
  -webkit-transform: none !important;
}
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 95%;
}
.search-overlay-dialog {
  margin: 40px;              /* Abstand zum Rand */
  border-radius: 12px;
  height: 90vh;       /* 🔥 statt max-height */
  max-height: 90vh;
}
:deep(.search-overlay-dialog) {
  padding-right: 6px !important;
  padding-left: 0px !important;
  padding-top: 16px !important;
  padding-bottom: 65px !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  margin-left: 56px !important;
  margin-right: 0px !important;
}

</style>